<template>
  <div class="slider-component">
    <div class="label text-center">
      Höhe des Saugroboters: <strong>{{ displayValue }}</strong> <br /> <br />
    </div>
    <div class="slider-wrapper">
      <div ref="slider"></div>
    </div>
  </div>
</template>

<script>
import noUiSlider from 'nouislider'
import 'nouislider/dist/nouislider.css'

export default {
  name: 'SliderComponent',
  props: {
    // Grenzen in cm (min optional; wenn nicht gesetzt, 0)
    minSize: { type: Number, default: 9 },
    maxSize: { type: Number, default: 17 },
    step:    { type: Number, default: 0.1 },
    showTooltip: { type: Boolean, default: true },
    // optional: Startwert, falls gewünscht
    value: { type: Number, default: null }
  },
  data() {
    return {
      currentCm: this.clamp(this.value ?? this.maxSize, this.minSize, this.maxSize)
    }
  },
  computed: {
    displayValue() {
      const decimals = this.step < 1 ? 1 : 0
      return `${this.currentCm.toFixed(decimals)} cm`
    }
  },
  mounted() { this.initSlider() },
  beforeDestroy() { this.$refs.slider?.noUiSlider?.destroy() },
  beforeUnmount() { this.$refs.slider?.noUiSlider?.destroy() },
  methods: {
    clamp(v, min, max) { return Math.min(Math.max(v, min), max) },
    initSlider() {
      const el = this.$refs.slider
      const decimals = this.step < 1 ? 1 : 0

      noUiSlider.create(el, {
        start: this.currentCm,
        connect: 'lower',
        range: { min: this.minSize, max: this.maxSize },
        step: this.step,
        tooltips: this.showTooltip,
        format: {
          to: (value) => `${Number(value).toFixed(decimals)} cm`,
          from: (value) =>
            parseFloat(String(value).replace(' cm', '').replace(',', '.'))
        }
      })

      el.noUiSlider.on('update', (values) => {
  const cm = Number(String(values[0]).replace(' cm', '').replace(',', '.'))
  this.currentCm = cm
  // <-- statt einer Zahl jetzt ein Objekt mit zwei Werten
  this.$emit('update-slider', { minSize: this.minSize, maxSize: cm })
})

// optional: direkt nach create den Initialwert einmal senden
const initCm = this.currentCm
this.$emit('update-slider', { minSize: this.minSize, maxSize: initCm })
    },
    updateOptions() {
      const s = this.$refs.slider?.noUiSlider
      if (!s) return
      const decimals = this.step < 1 ? 1 : 0
      s.updateOptions({
        range: { min: this.minSize, max: this.maxSize },
        step: this.step,
        format: {
          to: (value) => `${Number(value).toFixed(decimals)} cm`,
          from: (value) =>
            parseFloat(String(value).replace(' cm', '').replace(',', '.'))
        }
      })
      s.set(this.clamp(this.currentCm, this.minSize, this.maxSize))
    }
  },
  watch: {
    minSize() { this.updateOptions() },
    maxSize() { this.updateOptions() },
    step()    { this.updateOptions() }
  }
}
</script>

<style>
.slider-component { width: 70%; margin: 5% auto; }
.slider-wrapper { width: 100%; }
.noUi-handle { background-color: #E7EFFB; }
.noUi-connect { background-color: #6CB5F5; }
.label { margin: 16px 0; text-align: center; }
</style>
